import React from 'react'
import styled from 'styled-components'

import { typographyVariants } from './store'
import { COLORS } from '@/constants/colors'

const TypographyContainer = styled.span.attrs(props => ({
    style: {
        display: props.display,
        textAlign: props.$align,
        textOverflow: props.textOverflow,
        textTransform: props.textTransform,
        color: props.color,
        whiteSpace: props.whiteSpace,
    },
}))`
  margin: 0;
  font-family: Roboto;
  text-align: ${({ align }) => align || 'left'};
  display: ${({ display }) => display || 'block'};

  white-space: ${({ isNoWrap, whiteSpace }) =>
    whiteSpace ? whiteSpace : isNoWrap ? 'nowrap' : 'normal'};
  color: ${({ color }) => color || COLORS.blackHighEmphasis};

  ${Object.keys(typographyVariants).map(
    variant => `
    &[data-variant='${variant}'] {
      font-size: ${typographyVariants[variant].fontSize};
      font-weight: ${typographyVariants[variant].fontWeight};
      line-height: ${typographyVariants[variant].lineHeight};
      color: ${typographyVariants[variant].color || COLORS.blackHighEmphasis};
      text-transform: ${typographyVariants[variant].textTransform || 'none'};
      letter-spacing: ${typographyVariants[variant].letterSpacing || 'normal'};
    }
  `,
)}
`

const Typography = ({
    variant = 'body1',
    display,
    align = 'inherit',
    color,
    textOverflow,
    textTransform,
    isNoWrap = false,
    wordBreak,
    whiteSpace,
    overflow,
    children,
}) => (
    <TypographyContainer
        data-variant={variant}
        $align={align}
        color={color}
        display={display}
        textOverflow={textOverflow}
        textTransform={textTransform}
        wordBreak={wordBreak}
        whiteSpace={whiteSpace}
        overflow={overflow}
        isNoWrap={isNoWrap}
    >
        {children}
    </TypographyContainer>
)

export { Typography, typographyVariants }